import { render, staticRenderFns } from "./ManagerRateePage.vue?vue&type=template&id=8890fdd4&"
import script from "./ManagerRateePage.vue?vue&type=script&lang=ts&"
export * from "./ManagerRateePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports